"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.ok = void 0;
/**
 * Create an `Ok` result of type `T`.
 *
 * @param value Value to associate with the result.
 */
function ok(value) {
    return {
        ok: true,
        value,
        unwrap: () => value
    };
}
exports.ok = ok;
/**
 * Create an `Error` result of type `T`.
 *
 * @param error Error value to associate with this result.
 */
function error(error) {
    return {
        ok: false,
        error,
        unwrap: () => {
            throw error;
        }
    };
}
exports.error = error;
//# sourceMappingURL=result.js.map